import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.state.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.show) = $event)),
    width: _ctx.state.options.width || 350,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          (_ctx.state.options.title)
            ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.options.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, { style: {"white-space":"pre-line"} }, {
            default: _withCtx(() => [
              (_ctx.state.options.icon)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.options.icon), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.state.message), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer(false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.options.buttonFalseText || 'No'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: _ctx.state.options.color || 'primary',
                variant: "text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.answer(true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.state.options.buttonTrueText || 'Yes'), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}